// @flow

import * as Immutable from 'immutable';
import * as _ from 'lodash';
import { autofill } from 'redux-form/immutable';

import type { State, Action, Dispatch } from '../../lib/types';
import { inicializaCampos } from './functions';
import {
  CAMPOS_EMITENTE, CAMPOS_DESTINATARIO, CAMPOS_DADOS_ITENS, CAMPOS_DADOS_CEST, CAMPOS_DADOS_OPERACAO,
  CAMPOS_TRANSACOES_CONSYSTE, CAMPOS_TRANSPORTE_NFCE, CAMPOS_PAGAMENTO, CAMPOS_DADOS_TOTAIS, CAMPOS_DADOS_ICMS,
  CAMPOS_DADOS_PIS, CAMPOS_DADOS_COFINS, CAMPOS_LOCAL_RETIRADA, CAMPOS_LOCAL_ENTREGA, CAMPOS_DADOS_ITEM_IBS_CBS,
  CAMPOS_DADOS_IMPOSTO_SELETIVO, CAMPOS_DADOS_ITEM_TOTAL, CAMPOS_DADOS_ITEM_DOCUMENTO_REFERENCIADO,
} from './constantes';

export const INICIALIZA_MODAL        = 'lista_documentos/nfce/INICIALIZA_MODAL',
             INICIALIZA_VALORES_NFCE = 'lista_documentos/nfce/INICIALIZA_VALORES_NFCE',
             REINICIA_VALORES_NFCE   = 'lista_documentos/nfce/REINICIA_VALORES_NFCE';

const DEFAULT_STATE_JS = {
  query: null, formato: 'txt', tipoDocumento: 'nfce', delimiter: ';', linhaPor: 1, salvarRelatorio: false, visibilidade: 'publica',
  dadosBasicos: {
    versao: false, modeloDescricao: false, chave: false, numero: false, serie: false, ambienteDescr: false,
    emitidoEm: false, naturezaOperacao: false, tipoOperacaoIdEDescr: false, destinoOperacao: false, tipoEmissao: false,
    finalidade: false, consumidorFinal: false, indicadorPresenca: false, situacaoSefaz: false, autorizadoEm: false,
    informacoesAdicionaisFisco: false, informacoesComplementares: false,
  },
  ...CAMPOS_TRANSACOES_CONSYSTE, ...CAMPOS_EMITENTE, ...CAMPOS_DESTINATARIO, ...CAMPOS_TRANSPORTE_NFCE,
  ...CAMPOS_DADOS_ITENS, ...CAMPOS_DADOS_OPERACAO, ...CAMPOS_DADOS_CEST, ...CAMPOS_DADOS_TOTAIS,
  ...CAMPOS_PAGAMENTO, ...CAMPOS_DADOS_ICMS,  ...CAMPOS_DADOS_PIS, ...CAMPOS_DADOS_COFINS, ...CAMPOS_LOCAL_RETIRADA,
  ...CAMPOS_LOCAL_ENTREGA, ...CAMPOS_DADOS_IMPOSTO_SELETIVO, ...CAMPOS_DADOS_ITEM_IBS_CBS,
  ...CAMPOS_DADOS_ITEM_TOTAL, ...CAMPOS_DADOS_ITEM_DOCUMENTO_REFERENCIADO
};

const DEFAULT_STATE = Immutable.fromJS(DEFAULT_STATE_JS);

export default function reducer(state : Immutable.Map = DEFAULT_STATE, action : Action) {
  switch (action.type) {
    case INICIALIZA_MODAL:
      return state.set('query', action.query);
    case INICIALIZA_VALORES_NFCE:
      return inicializaCampos(state, action.campos);
    case REINICIA_VALORES_NFCE:
      return DEFAULT_STATE.set('query', state.get('query'));
    default:
      return state;
  }
}

// selectors

export const rootSelector = (state : State) => state.getIn(['listaDocumentos', 'nfce'], DEFAULT_STATE);

// thunk actions

export function atualizaSelecaoTodos(campos : string[], valor : bool) {
  return async function(dispatch : Dispatch<*>) {
    campos.forEach((campo : string) => {
      const grupoCheckbox = _.cloneDeep(DEFAULT_STATE_JS[campo]);

      Object.keys(grupoCheckbox).forEach(k => grupoCheckbox[k] = valor);

      return dispatch(autofill('listaDocumentosNfce', campo, Immutable.fromJS(grupoCheckbox)));
    });
  };
}